var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.75,
    height: 27,
    viewBox: "0 0 33.75 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-photos",
    "data-name": "Icon ionic-ios-photos",
    transform: "translate(-1.125 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7292",
    "data-name": "Trazado 7292",
    d: "M32.625,10.125H9a2.257,2.257,0,0,0-2.25,2.25V29.25A2.257,2.257,0,0,0,9,31.5H32.625a2.257,2.257,0,0,0,2.25-2.25V12.375A2.257,2.257,0,0,0,32.625,10.125Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7293",
    "data-name": "Trazado 7293",
    d: "M7.031,8.156H30.375V6.75a2.257,2.257,0,0,0-2.25-2.25H3.375a2.257,2.257,0,0,0-2.25,2.25v18A2.257,2.257,0,0,0,3.375,27H4.781V10.406A2.257,2.257,0,0,1,7.031,8.156Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotos);
export default __webpack_public_path__ + "static/media/photos.0109d14a29ea1c8b4647433d7cdbff3a.svg";
export { ForwardRef as ReactComponent };